const MAP_SOCIALS = {
  'google+': 'google-plus',
  mailru: 'mailru-oauth'
};

const SOCIALS_TO_NORMALIZE = Object.keys(MAP_SOCIALS);

function normalizeSocialName(name) {
  if (SOCIALS_TO_NORMALIZE.includes(name)) {
    return MAP_SOCIALS[name];
  }

  return name.replace('.', '-');
}

// eslint-disable-next-line import/prefer-default-export
export function normalizeSocials(socials) {
  const res = {};
  ['primary', 'secondary', 'other'].forEach(type => {
    // eslint-disable-next-line no-multi-assign
    const socialType = (res[type] = []);

    socials[type].forEach(social => {
      socialType.push({
        ...social,
        name: normalizeSocialName(social.name)
      });
    });
  });
  return res;
}



// WEBPACK FOOTER //
// ./utils/normalizeSocials.js